<template>
  <div class="index-page"><!--style="background: #F7FAFC;"-->
    <template v-if="dashboardInfo">
      <AppBar class="mobile-version" @toggleDrawer="drawerState=$event" :value="drawerState" :tabs="tabs"/>
      <app-bar-desktop class="desktop-version" :tabs="tabs" />

      <v-navigation-drawer
        v-if="isMobile"
        v-model="drawerState"
        app
        :right="true"
        temporary
        style="top: 65px"
      >
        <v-list nav dense>
          <v-list-item-group
            active-class="deep-purple--text text--accent-4"
          >
            <v-list-item
              v-for="tab in tabs"
              :key="tab.name"
              @click="handleMobileTabClick(tab)"
            >
              <v-list-item-title>{{ tab.btnName }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <template v-if="$route.name === 'Home'">
        <Home/>
      </template>
      <template v-else>
        <v-main app class="index-main"><!--class="pt-16" style="margin-top: 10px;padding: 68px 16px;height: 100vh;"-->
          <router-view />
        </v-main>
      </template>

      <Footer :styles="{'border-radius': '10px 10px 0 0'}"/>
    </template>
    <template v-else>
      <loader/>
    </template>
  </div>
</template>

<script>
import fakeData from '@/assets/fakeData'
import Image from '@/mixins/Image'
import AppBar from '@/components/layouts/App-bar'
import AppBarDesktop from '@/components/layouts/App-bar-desktop'
import Footer from '@/components/layouts/Footer'
import Home from '@/views/home'
import Loader from '@/components/elements/loader'
import { mapActions, mapState } from 'vuex'
import { trackEvent } from '@/utils/analytics'

export default {
  name: 'Index',
  mixins: [Image],
  components: { AppBar, Home, Footer, AppBarDesktop, Loader },
  data: () => ({
    ...fakeData,
    drawerState: false,
    windowWidth: window.innerWidth
  }),
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted () {
    this.getPatientDashboard().then(() => {
      if (this.userProfile.firstLogin && this.userProfile.lead) {
        this.openPage(this.dashboardInfo.menuRefs, '/survey')
      }
      const self = this
      setTimeout(function () {
        self.getSchedule(self.dashboardInfo.menuRefs.scheduleVisitId)
      }, 500)
    })
  },
  methods: {
    ...mapActions(['logout']),
    ...mapActions('patients', ['getPatientDashboard']),
    ...mapActions('reports', ['getSchedule']),
    openPage (visit, path) {
      const newPath = 'history/visit/'
      this.$router.push({ path: newPath + visit.scheduleVisitId + path })
    },
    handleResize () {
      this.windowWidth = window.innerWidth

      if (this.windowWidth >= 1050 && this.drawerState) {
        this.drawerState = false
      }
    },
    goToPage (page) {
      this.$router.push(page)
    },
    handleMobileTabClick(tab) {
      this.drawerState = false
      trackEvent(this, `click_tab_${tab.name}`, 'Navigation', `Clicked Tab: ${tab.btnName}`, {
        tab_name: tab.name,
        tab_label: tab.btnName
      })
      if (tab.name === 'logout') {
        this.logout()
      } else {
        this.goToPage(tab.goTo)
      }
    }
  },
  computed: {
    ...mapState({
      dashboardInfo: state => state.patients.dashboardInfo,
      userProfile: state => state.userProfile,
      subscription: state => state.subscription
    }),
    tabs () {
      const features = (this.subscription?.features?.$values || []).map(f => f.toLowerCase())
      const hasDocumentsAccess = features.includes('documents')

      const allTabs = [
        { name: 'home', btnName: this.$t('appBar.menu.home'), goTo: '/' },
        //     // { name: 'survey', btnName: 'Survey', goTo: `/visit/${this.dashboardInfo.menuRefs.surveyVisitId}/survey` },
        //     // { name: 'visit', btnName: 'Schedule', goTo: `/visit/${this.dashboardInfo.menuRefs.surveyVisitId}/schedule` },
        { name: 'evaluations', btnName: this.$t('appBar.menu.evaluations'), goTo: '/evaluations' },
        {name: 'documents', btnName: this.$t('appBar.menu.documents'), goTo: '/documents'},
        { name: 'chat', btnName: this.$t('appBar.menu.chat'), goTo: '/chat' },
        { name: 'profile', btnName: this.$t('appBar.menu.myProfile'), goTo: '/profile' },
        { name: 'logout', btnName: this.$t('appBar.menu.logout'), goTo: '/sign-in' }
      ]
      return allTabs.filter(tab => {
        if (tab.name === 'documents') {
          return hasDocumentsAccess
        }
        return true
      })
    },
    isMobile() {
      return this.windowWidth < 1050
    }
  },
  watch: {
    '$route.name' (val) {
      if (val === 'Home') {
        this.getPatientDashboard()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/fonts.scss';
  .index-page {
    .index-main {
      //padding-bottom: 55px;
      //padding-top: 57px!important;
      padding: 57px 0 0!important;
    }
    .mobile-version {
      display: none;
    }
    .desktop-version {
      display: block;
    }

    @media screen and (max-width: 1050px) {
      .desktop-version {
        display: none;
      }
      .mobile-version {
        display: block;
      }
      .index-main {
        padding: 0 0 0!important;
      }
    }
  }
</style>
